// SearchFilter.js
import { faCaretDown, faFilter, faMagnifyingGlass, faSort, faX } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { useEffect, useState } from "react";

const defaultSearchOptions = {
  searchTerm: "",
  category: "",
  sortBy: "",
};

const SearchFilter = ({ onSearch }) => {
  const [searchOptions, setSearchOptions] = useState(defaultSearchOptions);

  const handleInputChange = (e) => {
    setSearchOptions({
      ...searchOptions,
      searchTerm: e.target.value,
    });
  };

  const handleCategoryChange = (e) => {
    setSearchOptions({
      ...searchOptions,
      category: e.target.value,
    });
  };

  const handleSortByChange = (e) => {
    setSearchOptions({
      ...searchOptions,
      sortBy: e.target.value,
    });
  };

  const handleSearch = () => {
    onSearch(searchOptions);
  };

  const handleClear = () => {
    setSearchOptions(defaultSearchOptions);
    onSearch(defaultSearchOptions);
  };
  useEffect(() => {
    onSearch(defaultSearchOptions);
  }, []);

  return (
    <>
      <div className="hidden md:mx-36 md:block my-6 flex flex-col md:flex-row items-center bg-gray-100 p-2">
        <div className="flex items-center mb-2 md:mb-0 ">
          {/* Search input */}
          <input
            type="text"
            placeholder="Search bakery..."
            value={searchOptions.searchTerm}
            onChange={handleInputChange}
            className="p-2 border  w-80 md:w-full mr-2"
          />
          <button
            onClick={handleSearch}
            className="bg-gray-500 text-white p-2 rounded hover:bg-blue-600 cursor-pointer mr-2"
          >
            <FontAwesomeIcon icon={faMagnifyingGlass} />
          </button>
          <button
              onClick={handleClear}
              className="bg-gray-300 text-gray-800 p-2 rounded hover:bg-gray-400 cursor-pointer"
            >
              <FontAwesomeIcon icon={faX} />
            </button>
          {/* Select category */}
        </div>

      </div>

      {/* mobile device only  */}

      <div className="md:hidden my-6 flex flex-col md:flex-row items-center sticky top-0 bg-gray-200 z-50  p-2">
        <div className="flex items-center w-full mb-2 md:mb-0 ">
          {/* Search input */}
          <input
            type="text"
            placeholder="Search bakery..."
            value={searchOptions.searchTerm}
            onChange={handleInputChange}
            className="p-2 border  w-full md:w-full mr-2"
          />
          <button
            onClick={handleSearch}
            className="bg-gray-500 text-white p-2 rounded hover:bg-blue-600 cursor-pointer mr-2"
          >
            <FontAwesomeIcon icon={faMagnifyingGlass} />
          </button>
          <button
              onClick={handleClear}
              className="bg-gray-300 text-gray-800 p-2 rounded hover:bg-gray-400 cursor-pointer"
            >
             <FontAwesomeIcon icon={faX} />
            </button>
          {/* Select category */}
        </div>

        
      </div>
      <div className="flex mx-auto md:w-4/5 md:ml-32 items-center justify-between mr-2 ">
        {/* Category filter */}
        <div className="flex items-center relative">
      <div className="absolute inset-y-0 left-0 flex items-center pl-2 pointer-events-none">
        <FontAwesomeIcon icon={faFilter} className="text-gray-500" />
      </div>
      <select
        className="p-2 pl-8 w-40 appearance-none outline-none focus:outline-none bg-transparent" // Removed border and added background transparency
      >
        <option value="">All</option>
        <option value="Chocolate">Chocolate</option>
        <option value="Vanilla">Vanilla</option>
        <option value="OtherProduct">Other Product</option>
        {/* Add more categories as needed */}
      </select>
    </div>

        {/* Sort by filter */}
        <div className="relative">
      <div className="absolute inset-y-0 left-0 flex items-center pl-2 pointer-events-none">
        <FontAwesomeIcon icon={faSort} className="text-gray-500" />
      </div>
      <select
        value={searchOptions.sortBy}
        onChange={handleSortByChange}
        className="p-2 pl-8 w-40 appearance-none outline-none focus:outline-none bg-transparent" // Removed border and added background transparency
      >
        <option value="">Sort by</option>
        <option value="LowToHigh">Low to..</option>
        <option value="HighToLow">High to..</option>
        {/* Add more sorting options as needed */}
      </select>
    </div>
      </div>
    </>
  );
};

export default SearchFilter;
